import FooterMenuList from './FooterMenuList';
import { FooterMenuListProps, FooterMenuListValueProps } from './types';

export type { FooterMenuListProps, FooterMenuListValueProps };
export default FooterMenuList;
